const apiPaths = require("./apiPaths");

const BASE_HOST = process.env.NODE_ENV === "development" ? "" : (process.env.VUE_APP_SERVER_URL || "");

export const config = {
  SERVER_URL:          BASE_HOST,
  API_URL:             `${BASE_HOST}${apiPaths.API}`,
  TOR_API_URL:         `${BASE_HOST}${apiPaths.TOR}`,
  COMM_API_URL:        `${BASE_HOST}${apiPaths.COMM}`,
  APP_API_URL:         `${BASE_HOST}${apiPaths.APP}`,
  PUBLIC_URL:          `${BASE_HOST}${apiPaths.PUBLIC}`,
  GRAPH_API_URL:       `${BASE_HOST}${apiPaths.GRAPH}`,
  CRM_API_URL:         `${BASE_HOST}${apiPaths.CRM}`,
  PORTAL_API_URL:      `${BASE_HOST}${apiPaths.PORTAL}`,
  PDFGENERATOR_API_URL:`${BASE_HOST}${apiPaths.PDFGENERATOR}`,
  EXPORT_API_URL:      `${BASE_HOST}${apiPaths.EXPORT}`,
  PERMISSIONS_API_URL: `${BASE_HOST}${apiPaths.PERMISSIONS}`,
  QUESTIONAIRE_API_URL:`${BASE_HOST}${apiPaths.QUESTIONAIRE}`,
  REGEL_API_URL:       `${BASE_HOST}${apiPaths.REGEL}`,
  CARBONE_API_URL:     `${BASE_HOST}${apiPaths.CARBONE}`,
  AUSWAHLWERTE_API_URL:`${BASE_HOST}${apiPaths.AUSWAHLWERTE}`,
  KOTLIN_API_URL:      `${BASE_HOST}${apiPaths.KOTLIN}`,
};
